module.exports = __webpack_public_path__ + "static/media/T1-01.a9e86165.svg";